import {Component, OnInit} from '@angular/core';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {Offer} from '../../../models/Offer';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseHttpService} from '../../../services/base-http/base-http.service';
import {TranslatableString} from '../../../models/TranslatableString';
import {MEDIA_URL} from '../../../shared/constants';
import {AreaService} from '../../../services/area/area.service';
import {UserService} from '../../../services/user/user.service';
import {User} from '../../../models/User';
import {OffersService} from '../../../services/offers/offers.service';
import {LanguageService} from '../../../services/languages/language.service';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss']
})
export class OfferComponent implements OnInit {
  selectedOffer: Offer;
  isCreatedOffer = false;
  similarOffers: Offer[];
  currencyType = 'EUR';
  printUrl = '../../../../assets/images/print.png';
  selectedPictureIndex: number;
  isMiniMapShown = false;
  isContactFormShown = false;
  isPrintableShown = false;
  isFullScreenPictureVisible = false;
  containerPositionTranslate = 'translateX(0%)';
  selectedUser: User;
  currentId: string;
  selectedCurrency: string;
  noImageAvailableUrl = 'src/assets/images/no-images-available.jpg';
  languageKey: string;

  constructor(
    public httpService: BaseHttpService,
    private areaService: AreaService,
    public userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    public offersService: OffersService,
    private titleService: Title,
    private languageService: LanguageService,
    private sanitizer: DomSanitizer) {
    this.languageService.currentLanguageKey.subscribe((val) => {
      this.languageKey = val;
    });
  }

  ngOnInit() {
    this.similarOffers = [];
    this.selectedCurrency = 'EUR';
    this.selectedUser = undefined;
    this.userService.whenUsersReady();
    this.route.params.subscribe(data => {
      this.currentId = data.id;
      this.loadingPage();
    });
  }

  loadingPage() {
    this.selectedPictureIndex = 0;
    this.getSelectedOffer(Number(this.currentId));
  }

  changeSelectedCurrencyTo(newCurrency: string) {
    if (newCurrency === 'BGN') {
      this.offersService.changeSelectedCurrencyTo(newCurrency);
      this.selectedCurrency = newCurrency;
    } else if (newCurrency === 'EUR') {
      this.offersService.changeSelectedCurrencyTo(newCurrency);
      this.selectedCurrency = newCurrency;
    }
  }

  getSelectedOffer(id: number): void {
    let tempOffData;
    let tempPicData;
    let tempSpecs;
    this.offersService.getSelectedOffer(id).subscribe(offData => {
      tempOffData = offData;
      if (tempOffData && tempPicData && tempSpecs) {
        this.selectedOffer = this.createOffers(
          tempOffData,
          tempPicData,
          tempSpecs
        )[0];
        this.isCreatedOffer = true;
        this.getCurrentUser(this.selectedOffer.contactUserNameBg);
        this.getSimilarOffers();
      }
    });
    this.offersService.getSelectedOfferPictures(id).subscribe(picData => {
      tempPicData = picData;
      if (tempOffData && tempPicData && tempSpecs) {
        this.selectedOffer = this.createOffers(
          tempOffData,
          tempPicData,
          tempSpecs
        )[0];
        this.isCreatedOffer = true;
        this.getCurrentUser(this.selectedOffer.contactUserNameBg);
        this.getSimilarOffers();
      }
    });
    this.offersService.getSelectedOfferPropertySpecifications(id).subscribe(specs => {
      tempSpecs = specs;
      if (tempOffData && tempPicData && tempSpecs) {
        this.selectedOffer = this.createOffers(
          tempOffData,
          tempPicData,
          tempSpecs
        )[0];
        this.titleService.setTitle('LOGOS - Недвижими имоти, продажби, наеми | Оферта ' + this.selectedOffer.id);
        this.isCreatedOffer = true;
        this.getCurrentUser(this.selectedOffer.contactUserNameBg);
        this.getSimilarOffers();
      }
    });
  }

  getCurrentUser(userName) {
    this.userService.getUsers().subscribe(users => {
      this.selectedUser = new User(users.find(user => user.name_bg === userName));
    });
  }

  getSimilarOffers() {
    const similarOffersDifferencePercentage = this.selectedOffer.isSellable === true ? 30 : 40;
    this.similarOffers = [];
    this.offersService.getOffers().subscribe(dataOffers => {
      const data = dataOffers
        .filter((offer) => offer.property_type.type_bg === this.selectedOffer.type.valueBg)
        .filter((offer) => offer.property_id !== this.selectedOffer.id)
        .filter((offer) => Math.abs(this.offersService.getPriceNumberValue(offer.property_price) -
          this.offersService.getPriceNumberValue(this.selectedOffer.price)) <
          this.offersService.getPriceNumberValue(this.selectedOffer.price) * (similarOffersDifferencePercentage / 100));
      data.forEach(element => {
        this.similarOffers.push(new Offer(element));
      });
    });
  }

  private createOffers(tempOffData, tempPicData, tempSpecs): Offer[] {
    const result = [];
    for (let i = 0; i < tempOffData.length; i++) {
      result[i] = new Offer(tempOffData[i]);
      const rawPics = tempPicData.filter(
        picture => picture.property_pictures_id.property_id === result[i].id
      );

      if (rawPics.filter(pic => pic.front_picture === true).length > 0) {
        result[i].pictures.push(
          MEDIA_URL + rawPics.filter(pic => pic.front_picture === true)[0].property_pictures
        );
        if (tempOffData[i].youtube_link) {
          result[i].pictures.push(
            MEDIA_URL + rawPics.filter(pic => pic.front_picture === true)[0].property_pictures
          );
        }
      }

      for (let j = 0; j < rawPics.length; j++) {
        if (!rawPics[j].front_picture) {
          if (tempOffData[i].youtube_link && j === 0) {
            result[i].pictures.push(
              MEDIA_URL + rawPics[j].property_pictures
            );
          }
          result[i].pictures.push(
            MEDIA_URL + rawPics[j].property_pictures
          );
        }
      }
    }
    for (const specs of tempSpecs) {
      const specTranslatableStr = new TranslatableString(
        specs.property_feature.feature,
        specs.property_feature.feature_en,
        specs.property_feature.feature_bg,
        specs.property_feature.feature_ru
      );
      result
        .find(
          offer => offer.id === specs.property_features_id.property_id
        )
        .specifications.push(specTranslatableStr);
    }
    return result;
  }

  cliCkOpenFullScreenPicture(): void {
    this.isFullScreenPictureVisible = true;
  }

  cliCkCloseFullScreenPicture(): void {
    this.isFullScreenPictureVisible = false;
  }

  clickOnPrintOffer() {
    this.isPrintableShown = true;
    setTimeout(() => {
      window.print();
      this.isPrintableShown = false;
    }, 50);
  }

  clickArrowRight(): void {
    if (this.selectedPictureIndex < this.selectedOffer.pictures.length - 1) {
      this.selectedPictureIndex++;
      this.setPicturesContainerPosition(this.selectedPictureIndex);
    }
  }

  clickArrowLeft(): void {
    if (this.selectedPictureIndex > 0) {
      this.selectedPictureIndex--;
      this.setPicturesContainerPosition(this.selectedPictureIndex);
    }
  }

  setPicturesContainerPosition(pictureIndex: number): void {
    let translateXValue = 0;
    if (this.selectedOffer.pictures.length === 1) {
      translateXValue = 15;
    } else if (this.selectedOffer.pictures.length === 2) {
      translateXValue = 10;
    } else {
      if (pictureIndex < 2) {
        translateXValue = 0;
      } else if (pictureIndex > this.selectedOffer.pictures.length - 3) {
        translateXValue = (pictureIndex - 2) * -10;
      } else {
        translateXValue = (pictureIndex - 2) * -10;
      }
    }
    this.containerPositionTranslate = 'translateX(' + (translateXValue / 10) + '%)';
  }

  clickOfferImage(pictureIndex: number): void {
    this.selectedPictureIndex = pictureIndex;
    this.setPicturesContainerPosition(this.selectedPictureIndex);
  }

  canShowOnMiniMap(): boolean {
    if (this.areaService.areas.find((area) => area.name === this.selectedOffer.area.valueBg)) {
      return true;
    }
    return false;
  }

  closeMiniMap(): void {
    this.isMiniMapShown = false;
  }

  clickSendRequest(): void {
    this.isContactFormShown = true;
  }

  closeContactForm(): void {
    this.isContactFormShown = false;
  }

  clickSeeOnMap(): void {
    this.isMiniMapShown = true;
  }

  changeToDifferentOffer(id: number): void {
    this.selectOffer(id);
    setTimeout(() => {
      // this.loadPageFromUrl();
    }, 100);
  }

  clickOnLikeOffer(): void {
    if (!localStorage.getItem('likes') ||
      localStorage.getItem('likes').split(' ').indexOf(this.selectedOffer.id.toString()) === -1) {
      this.httpService.postNewOfferLike(this.selectedOffer.id).subscribe((data) => {
        localStorage.setItem('likes', localStorage.getItem('likes') + ' ' + this.selectedOffer.id);
        this.selectedOffer.likeCounter++;
      });
    } else {
      window.alert('You cannot like an offer twice !');
    }
  }

  selectOffer(offerID: number): void {
    this.router.navigate([this.languageKey + '/offer/' + offerID.toString()]);
  }
}
